import React from 'react';

import { ServiceTitanAdjustableCapacityDTO } from '_lib/api/apiTypes.shim';
import { Typography } from '_lib/components/Typography/Typography';

type AvailabilityPercentageProps = { capacityItem: ServiceTitanAdjustableCapacityDTO };

export const AvailabilityPercentage = ({
  capacityItem: { openAvailability, totalAvailability }
}: AvailabilityPercentageProps) => {
  const percentageUsed =
    totalAvailability > 0 && openAvailability > 0
      ? Math.floor(((totalAvailability - openAvailability) / totalAvailability) * 100)
      : 0;

  const percentage = 100 - percentageUsed;

  return <Typography text={`${percentage}% Open`} />;
};
